import { Observable, map } from 'rxjs';
import type {
  CreateCustomFieldValueData,
  UpdateCustomFieldValueData,
  ICustomFieldValueApiService,
} from '../domain/abstractions/ICustomFieldValueApiService';
import { ICustomFieldValueRepository } from '../domain/abstractions/ICustomFieldValueRepository';
import { inject, injectable } from 'inversify';
import { CUSTOM_FIELD_VALUE_TYPES } from '../di/types';
import CustomFieldValueEntity from 'src/db/entities/customFieldValue/CustomVieldValueEntity';
import type { ICustomFieldValueDao } from '../domain/abstractions/ICustomFieldValueDao';

@injectable()
export default class CustomFieldValueRepository implements ICustomFieldValueRepository {
  @inject(CUSTOM_FIELD_VALUE_TYPES.CustomFieldValueApiService)
  private api: ICustomFieldValueApiService;
  @inject(CUSTOM_FIELD_VALUE_TYPES.CustomFieldValueDao) private dao: ICustomFieldValueDao;

  createValue(data: CreateCustomFieldValueData): Observable<string> {
    const now = Math.floor(Date.now() / 1000);
    return this.dao
      .upsert({
        ...data,
        createdAt: now,
        updatedAt: now,
      })
      .pipe(
        map(() => {
          this.api.createValue(data);

          return data.uuid;
        })
      );
  }

  updateValue(data: UpdateCustomFieldValueData): Observable<string> {
    const now = Math.floor(Date.now() / 1000);
    return this.dao
      .upsert({
        ...data,
        updatedAt: now,
      })
      .pipe(
        map(() => {
          this.api.updateValue({
            uuid: data.uuid,
            value: data.value,
          });

          return data.uuid;
        })
      );
  }

  getAll(contactUuid?: string): Observable<CustomFieldValueEntity[]> {
    return this.dao.getAll(contactUuid);
  }
}
